export default "__VITE_ASSET__CTP_UgCf__"